import { render, staticRenderFns } from "./EcoHubTechUserCreate.vue?vue&type=template&id=11dd789a"
import script from "./EcoHubTechUserCreate.vue?vue&type=script&lang=js"
export * from "./EcoHubTechUserCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports